import React from 'react';


import NoControlsPlayer from './NoControlsPlayer';
import ShootstaPlayer from './ShootstaPlayer';
import WithControlsPlayer from './WithControlsPlayer';


import { VideoMode } from '../../../../types';

const Video = (props) => {
  const { mode, ...otherProps } = props;

  if (mode === VideoMode.SHOOTSTA_PLAYER) {
    return <ShootstaPlayer {...otherProps} />;
  }

  if (mode === VideoMode.PLAYER_CONTROLS) {
    return <WithControlsPlayer {...otherProps} />;
  }

  if (mode === VideoMode.PLAYER_NO_CONTROLS) {
    return <NoControlsPlayer {...otherProps} />;
  }

  return null;
};

export default Video;